import { Icon } from "@chakra-ui/react";
import { TIconComponent } from "src/components/icons";

export const IconTrending: TIconComponent = props => (
    <Icon viewBox="0 0 24 24" {...props}>
        <g fill="none" fillRule="evenodd">
            <g transform="translate(2 2)" fill="currentColor" fillRule="nonzero">
                <path
                    d="M9.952 4.96709L6.51304 11.8519H9.70814C10.4183 11.8519 10.9354 12.5257 10.7525 13.2125L9.68407 17.223L16.637 10.8683H11.9601C11.1567 10.8683 10.6341 10.022 10.9934 9.30261L13.159 4.96709H9.952ZM8.43876 3.59806C8.62184 3.23153 8.99609 3 9.40547 3H14.5898C15.3933 3 15.9159 3.84638 15.5566 4.56574L13.391 8.90126H18.917C19.9038 8.90126 20.3745 10.1161 19.6458 10.7821L8.78099 20.7121C7.98391 21.4406 6.7298 20.6783 7.0079 19.6343L8.55712 13.819H5.08221C4.27875 13.819 3.75618 12.9726 4.1155 12.2532L8.43876 3.59806Z"
                    fill="#333333"
                />
            </g>
        </g>
    </Icon>
);
